const DAYS_OF_WEEK = {
  monday: {
    index: 1,
    key: "monday",
    i18nKey: "frontend.shared.common.monday",
  },
  tuesday: {
    index: 2,
    key: "tuesday",
    i18nKey: "frontend.shared.common.tuesday",
  },
  wednesday: {
    index: 3,
    key: "wednesday",
    i18nKey: "frontend.shared.common.wednesday",
  },
  thursday: {
    index: 4,
    key: "thursday",
    i18nKey: "frontend.shared.common.thursday",
  },
  friday: {
    index: 5,
    key: "friday",
    i18nKey: "frontend.shared.common.friday",
  },
  saturday: {
    index: 6,
    key: "saturday",
    i18nKey: "frontend.shared.common.saturday",
  },
  sunday: {
    index: 7,
    key: "sunday",
    i18nKey: "frontend.shared.common.sunday",
  },
};

const MONTHS = {
  january: {
    key: "january",
    i18nKey: "frontend.shared.common.january",
  },
  february: {
    key: "february",
    i18nKey: "frontend.shared.common.february",
  },
  march: {
    key: "march",
    i18nKey: "frontend.shared.common.march",
  },
  april: {
    key: "april",
    i18nKey: "frontend.shared.common.april",
  },
  may: {
    key: "may",
    i18nKey: "frontend.shared.common.may",
  },
  june: {
    key: "june",
    i18nKey: "frontend.shared.common.june",
  },
  july: {
    key: "july",
    i18nKey: "frontend.shared.common.july",
  },
  august: {
    key: "august",
    i18nKey: "frontend.shared.common.august",
  },
  september: {
    key: "september",
    i18nKey: "frontend.shared.common.september",
  },
  october: {},
  november: {
    key: "november",
    i18nKey: "frontend.shared.common.november",
  },
  december: {
    key: "december",
    i18nKey: "frontend.shared.common.december",
  },
};

module.exports = {
  DAYS_OF_WEEK,
  MONTHS,
};
